<oaibox-stats-card
  title="Configuration Files"
  icon="fa-regular fa-file-code"
  gradient="secondary"
>
  <div class="configuration-files-content d-flex align-items-stretch">
    <ul class="configuration-files-list">
      <li>
        <button
          class="configuration-file-button success"
          [class.selected]="!selectedConfigurationDetails"
          (click)="cleanSelectedConfigurationFile()"
        >
          New Configuration File
          <i class="fa-regular fa-file-circle-plus"></i>
        </button>
      </li>
      <li class="config-file-search-box-wrapper">
        <input
          class="config-file-search-box"
          type="text"
          placeholder="Search"
          [class.selected]="!selectedConfigurationDetails"
          [(ngModel)]="searchKeyword"
          (ngModelChange)="searchFiles($event)"
        />
        @if (!searchKeyword) {
          <i class="fa-solid fa-magnifying-glass input-suffix"></i>
        } @else {
          <button
            class="clean-search-button input-suffix"
            (click)="searchFiles(undefined)"
          >
            <i class="fa-solid fa-xmark"></i>
          </button>
        }
      </li>
      @for (
        configurationFileDetails of shownConfigurationFiles;
        track configurationFileDetails
      ) {
        <li>
          <button
            class="configuration-file-button secondary ellipsis"
            [class.selected]="
              selectedConfigurationDetails?.id === configurationFileDetails.id
            "
            (click)="selectFileConfiguration(configurationFileDetails)"
          >
            <div class="ellipsis">
              <i class="fa-regular fa-file-lines"></i>
              {{ configurationFileDetails.filename }}
            </div>
            @if (configurationFileDetails.description) {
              <div class="under-label ellipsis">
                {{ configurationFileDetails.description }}
              </div>
            }
          </button>
        </li>
      }
    </ul>
    <div class="configuration-file-form flex-fill">
      <form [formGroup]="configurationFileForm" class="form p-g g-g h-100">
        <div class="form-row">
          <div class="flex-fill">
            <label class="form-label">Filename</label>
            <input
              type="text"
              class="form-control"
              formControlName="filename"
            />
          </div>
          <div class="flex-fill">
            <label class="form-label">Description</label>
            <input
              type="text"
              class="form-control"
              formControlName="description"
            />
          </div>
        </div>
        <div class="d-flex flex-column flex-fill">
          <label class="form-label">File Content</label>
          <div class="file-input-container flex-fill">
            <!-- Text Content -->
            @if (!configurationFileForm.value.binaryContent) {
              <div class="h-100">
                @if (!configurationFileForm.value.textFileContent) {
                  <div class="input-info">
                    <p class="input-placeholder">
                      Place your file content
                      <i class="fa-regular fa-file-lines"></i> here.
                    </p>
                    Or drop a file
                    <i class="fa-regular fa-file-arrow-up"></i> to here!
                  </div>
                }
                <textarea
                  class="form-control file-text-input h-100"
                  formControlName="textFileContent"
                  oaiboxFileDropZone
                  (droppedFiles)="loadFile($event)"
                ></textarea>
              </div>
            }

            <!-- Binary File -->
            @if (configurationFileForm.value.binaryContent) {
              <div class="h-100">
                <div class="input-info">
                  <i class="fa-solid fa-circle-info primary"></i> File preview
                  not available!<br />
                  <p class="filename">
                    <i class="fa-regular fa-file"></i>
                    {{ configurationFileForm.value.filename }}
                  </p>
                </div>
                <label
                  class="form-control file-text-input not-preview h-100"
                  for="file-upload"
                  oaiboxFileDropZone
                  (droppedFiles)="loadFile($event)"
                >
                  <input class="d-none" type="file" id="file-upload" (change)="fileInput($event)" />
                </label>
              </div>
            }

            <div class="actions-container">
              @if (configurationFileForm.value.textFileContent) {
                <button
                  class="action-button secondary"
                  #copyButton
                  (click)="copyContent(copyButton)"
                >
                  <i class="fa-solid fa-clone"></i> Copy
                </button>
              }

              @if (
                configurationFileForm.value.textFileContent ||
                configurationFileForm.value.binaryContent
              ) {
                <button
                  class="action-button danger"
                  (click)="cleanFileContent()"
                >
                  <i class="fa-solid fa-eraser"></i> Erase
                </button>
              }

              <label class="action-button primary" for="file-upload-button">
                <input
                  class="d-none"
                  type="file"
                  id="file-upload-button"
                  (change)="fileInput($event)"
                />
                <i class="fa-regular fa-file-arrow-up"></i> Load File
              </label>
            </div>

            @if (isLoading) {
              <div class="is-loading-backdrop">
                <div class="is-loading">
                  <i class="fa-solid fa-spinner primary rotating"></i> Loading
                  File
                </div>
              </div>
            }
          </div>
        </div>
        <div class="d-flex justify-content-end g-g">
          @if (selectedConfigurationDetails) {
            <button
              type="button"
              class="btn btn-danger"
              (click)="deleteFileConfiguration()"
            >
              Delete
            </button>
          }
          @if (selectedConfigurationDetails) {
            <button
              type="submit"
              class="btn btn-success"
              (click)="updateFileConfiguration()"
              [disabled]="configurationFileForm.invalid"
            >
              Update Configuration File
            </button>
          } @else {
            <button
              type="submit"
              class="btn btn-success"
              (click)="createFileConfiguration()"
              [disabled]="configurationFileForm.invalid"
            >
              Create Configuration File
            </button>
          }
        </div>
      </form>

      @if (isSaving) {
        <div class="is-saving-backdrop">
          <div class="is-saving">
            <i class="fa-solid fa-spinner primary rotating"></i> Saving File
          </div>
        </div>
      }
    </div>
  </div>
</oaibox-stats-card>
